
    (function () {
      var COOKIE_NAME = 'newsletter_popup_shown';
      var COOKIE_DAYS = 7;

      function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
      }

      function setCookie(name, value, days) {
        var expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = name + '=' + value + '; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
      }

      function showPopup() {
        var overlay = document.getElementById('newsletter-popup-overlay');
        if (!overlay) return;
        overlay.style.display = 'flex';
        overlay.removeAttribute('aria-hidden');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            overlay.classList.add('is-visible');
          });
        });
      }

      function hidePopup() {
        var overlay = document.getElementById('newsletter-popup-overlay');
        if (!overlay) return;
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
        setTimeout(function () {
          overlay.style.display = 'none';
        }, 350);
        setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
      }

      document.addEventListener('DOMContentLoaded', function () {
        if (window.Shopify && window.Shopify.designMode) {
          if (sessionStorage.getItem('popup_shown_editor')) return;
          sessionStorage.setItem('popup_shown_editor', '1');
        } else {
          if (getCookie(COOKIE_NAME)) return;
        }

        var closeBtn = document.getElementById('newsletter-popup-close');
        var overlay  = document.getElementById('newsletter-popup-overlay');
        if (!overlay) return;

        var DELAY_MS = parseInt(overlay.dataset.delay, 10) || 3000;

        if (closeBtn) {
          closeBtn.addEventListener('click', hidePopup);
        }

        if (overlay) {
          overlay.addEventListener('click', function (e) {
            if (e.target === overlay) hidePopup();
          });
        }

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') hidePopup();
        });

        setTimeout(showPopup, DELAY_MS);
      });
    })();